import { createContext, useContext } from "react";

import type { FormSpec } from "../connector-content/interface";
import type { ConnectorModalProps } from "../connector-modal";

export type ConnectHandler = (any) => any;
export type openConnectorModal = (
  name?: string,
  connectHandler?: ConnectHandler,
  title?: string,
  formFields?: FormSpec,
  link?: ConnectorModalProps["link"],
  showRutterDisclaimer?: boolean,
  showCodatDisclaimer?: boolean
) => any;

export type ConnectorContextValue = {
  openConnectorModal: openConnectorModal;
  updateConnectorModalFields: (
    name: string,
    formFields: FormSpec,
    showRutterDisclaimer?: boolean,
    showCodatDisclaimer?: boolean,
    link?: ConnectorModalProps["link"]
  ) => void;
  closeConnectorModal: () => void;
};

export interface ConnectorProviderProps {
  children: React.ReactNode;
}

const ProviderMissingError = new Error("Provider not found, components should be wrapped in ConnectorProvider");

export const ConnectorContext = createContext<ConnectorContextValue>({
  openConnectorModal: () => {
    throw ProviderMissingError;
  },
  updateConnectorModalFields: () => {
    throw ProviderMissingError;
  },
  closeConnectorModal: () => {
    throw ProviderMissingError;
  },
});

export type ModalProps = {
  name: string;
  connectHandler: () => any;
  title?: string;
  formFields?: FormSpec;
  link?: ConnectorModalProps["link"];
  showRutterDisclaimer?: boolean;
  showCodatDisclaimer?: boolean;
};

export type InactiveModalState = { name: "inactive" };
export const inactiveModalState: InactiveModalState = { name: "inactive" };

export const useConnector = (): ConnectorContextValue => useContext(ConnectorContext);
